// extracted by mini-css-extract-plugin
module.exports = {"mapDashboard":"MapDashboard_mapDashboard__19jRf","Map":"MapDashboard_Map__2QiNS","mapTools":"MapDashboard_mapTools__25jL7","miniGlobe":"MapDashboard_miniGlobe__3BxUb"};